import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { setDoc, doc } from "firebase/firestore";
import { firebaseAuth, pokemonListRef } from "../../utils/firebaseConfig";

export const addListToDatabase = createAsyncThunk(
  "pokemon/addPokemonList",
  async (_, { getState }) => {
    try {
      const {
        app: { userInfo },
        pokemon: { userPokemons },
      } = getState() as RootState;

      const uid = firebaseAuth.currentUser?.uid;
      if (!userInfo?.email || !uid) return;

      await setDoc(
        doc(pokemonListRef, uid),
        { email: userInfo.email, pokemon: userPokemons },
        { merge: true }
      );
    } catch (err) {
      console.error("Failed to sync collection to Firestore", err);
    }
  }
);

export default addListToDatabase;
